export const SETTINGS_PAGE_WRAPPER_TEST_ID = "settings-page-wrapper";
export const SETTINGS_TOP_BAR_TEST_ID = "settings-top-bar";
export const SETTINGS_TOP_BAR_TITLE_TEST_ID = "settings-top-bar-title";
export const SETTINGS_TABS_TEST_ID = "settings-tabs";
export const SETTINGS_OVERVIEW_TAB_TEST_ID = "settings-tab-overview";
export const SETTINGS_PEOPLE_TAB_TEST_ID = "settings-tab-people";
export const SETTINGS_API_MCP_TAB_TEST_ID = "settings-tab-api-mcp";
export const SETTINGS_HORIZONTAL_BAR_TEST_ID = "settings-horizontal-bar";
export const SETTINGS_ROLE_CHIP_TEST_ID = "settings-page-chip";
export const SETTINGS_PAGE_LOADER_TEST_ID = "settings-page-loader";
